import React from "react";
import cx from "classnames";

const ProfileTabs = ({ section, athlete, query }) => {
  const organizationCoach = query.organizationCoach || undefined;

  return (
    <React.Fragment>
      <nav role="tablist">
        <a
          aria-current={section === "dashboard" ? true : undefined}
          href={
            organizationCoach
              ? `/athlete-portal/profile?section=dashboard&athlete=${athlete._id}&organizationCoach=${organizationCoach}`
              : `/athlete-portal/profile?section=dashboard&athlete=${athlete._id}`
          }
        >
          Dashboard
        </a>
        <a
          aria-current={section === "coachvideos" ? true : undefined}
          href={
            organizationCoach
              ? `/athlete-portal/profile?section=coachvideos&athlete=${athlete._id}&organizationCoach=${organizationCoach}`
              : `/athlete-portal/profile?section=coachvideos&athlete=${athlete._id}`
          }
        >
          Coach Videos
        </a>
        <a
          aria-current={section === "questionnaire" ? true : undefined}
          href={
            organizationCoach
              ? `/athlete-portal/profile?section=questionnaire&athlete=${athlete._id}&organizationCoach=${organizationCoach}`
              : `/athlete-portal/profile?section=questionnaire&athlete=${athlete._id}`
          }
        >
          Check-in Questionnaire
        </a>
        <a
          aria-current={section === "accountability" ? true : undefined}
          href={
            organizationCoach
              ? `/athlete-portal/profile?section=accountability&athlete=${athlete._id}&organizationCoach=${organizationCoach}`
              : `/athlete-portal/profile?section=accountability&athlete=${athlete._id}`
          }
        >
          Daily Accountability
        </a>
        <a
          aria-current={section === "tasks" ? true : undefined}
          href={
            organizationCoach
              ? `/athlete-portal/profile?section=tasks&athlete=${athlete._id}&organizationCoach=${organizationCoach}`
              : `/athlete-portal/profile?section=tasks&athlete=${athlete._id}`
          }
        >
          Tasks
        </a>
        <a
          aria-current={section === "guides" ? true : undefined}
          href={
            organizationCoach
              ? `/athlete-portal/profile?section=guides&athlete=${athlete._id}&organizationCoach=${organizationCoach}`
              : `/athlete-portal/profile?section=guides&athlete=${athlete._id}`
          }
        >
          Guides
        </a>
      </nav>
    </React.Fragment>
  );
};

export default ProfileTabs;
